var map = {
	"./animation.js": "./src/js/tools/animation.js",
	"./blur.js": "./src/js/tools/blur.js",
	"./brush.js": "./src/js/tools/brush.js",
	"./bulge_pinch.js": "./src/js/tools/bulge_pinch.js",
	"./clone.js": "./src/js/tools/clone.js",
	"./crop.js": "./src/js/tools/crop.js",
	"./desaturate.js": "./src/js/tools/desaturate.js",
	"./erase.js": "./src/js/tools/erase.js",
	"./fill.js": "./src/js/tools/fill.js",
	"./gradient.js": "./src/js/tools/gradient.js",
	"./magic_erase.js": "./src/js/tools/magic_erase.js",
	"./media.js": "./src/js/tools/media.js",
	"./pencil.js": "./src/js/tools/pencil.js",
	"./pick_color.js": "./src/js/tools/pick_color.js",
	"./select.js": "./src/js/tools/select.js",
	"./selection.js": "./src/js/tools/selection.js",
	"./shape.js": "./src/js/tools/shape.js",
	"./shapes/arrow.js": "./src/js/tools/shapes/arrow.js",
	"./shapes/bezier_curve.js": "./src/js/tools/shapes/bezier_curve.js",
	"./shapes/callout.js": "./src/js/tools/shapes/callout.js",
	"./shapes/cog.js": "./src/js/tools/shapes/cog.js",
	"./shapes/cylinder.js": "./src/js/tools/shapes/cylinder.js",
	"./shapes/ellipse.js": "./src/js/tools/shapes/ellipse.js",
	"./shapes/heart.js": "./src/js/tools/shapes/heart.js",
	"./shapes/hexagon.js": "./src/js/tools/shapes/hexagon.js",
	"./shapes/human.js": "./src/js/tools/shapes/human.js",
	"./shapes/line.js": "./src/js/tools/shapes/line.js",
	"./shapes/moon.js": "./src/js/tools/shapes/moon.js",
	"./shapes/parallelogram.js": "./src/js/tools/shapes/parallelogram.js",
	"./shapes/pentagon.js": "./src/js/tools/shapes/pentagon.js",
	"./shapes/plus.js": "./src/js/tools/shapes/plus.js",
	"./shapes/polygon.js": "./src/js/tools/shapes/polygon.js",
	"./shapes/rectangle.js": "./src/js/tools/shapes/rectangle.js",
	"./shapes/right_triangle.js": "./src/js/tools/shapes/right_triangle.js",
	"./shapes/romb.js": "./src/js/tools/shapes/romb.js",
	"./shapes/star.js": "./src/js/tools/shapes/star.js",
	"./shapes/tear.js": "./src/js/tools/shapes/tear.js",
	"./shapes/trapezoid.js": "./src/js/tools/shapes/trapezoid.js",
	"./shapes/triangle.js": "./src/js/tools/shapes/triangle.js",
	"./sharpen.js": "./src/js/tools/sharpen.js",
	"./text.js": "./src/js/tools/text.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/tools sync recursive \\.js$";